module.exports = __webpack_public_path__ + "static/media/JPY.d3445e0a.svg";